import styled from "styled-components";
import {Table} from "antd";

export const TableContainer = styled(Table)`
    width: 100%;
    flex: 1;

    @media screen and (max-width: 768px) {
        .ant-table {
            overflow-x: auto;
        }

        .ant-table table {
            min-width: 100%;
        }

        .ant-table table td {
            display: ${props => props.display};
            grid-template-columns: 1fr;
            justify-content: flex-start;
            align-items: flex-start;
            text-align: left;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }

        .ant-table-cell {
            flex-direction: column;
            align-items: flex-start;
            padding: 8px 12px !important;
        }

        .ant-table table th {
            display: none;
        }

        .ant-table table td::before {
            font-weight: bold;
            padding-right: 8px;
            color: #666;
            min-width: 80px;
            display: inline-block;
        }

        .ant-table table tr td {
            padding: 8px 12px !important;
            border-bottom: 1px solid #f0f0f0;
        }

        .ant-table table tr td:first-child {
            padding-top: 12px !important;
        }

        .ant-table table tr td:last-child {
            padding-bottom: 12px !important;
        }

        ${props =>
            props.dataTitles.map(
                (title, index) =>
                    `.ant-table table td:nth-child(${index + 1})::before {
                content: "${title}: ";
            }`
            )}

        .ant-table table tr {
            outline: 1px solid #f0f0f0;
            margin-bottom: 16px;
            margin-top: 16px;
            display: block;
            border-radius: 8px;
            -webkit-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            -moz-box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
            background: white;
        }

        .ant-table-tbody > tr:hover > td {
            background: #fafafa;
        }

        .ant-table-pagination {
            margin: 16px 0;
            text-align: center;
        }
    }

    @media screen and (max-width: 480px) {
        .ant-table table td {
            font-size: 14px;
        }

        .ant-table table td::before {
            font-size: 13px;
            min-width: 70px;
        }

        .ant-table table tr td {
            padding: 6px 8px !important;
        }
    }
`;

export const ActionButtons = styled.div`
    flex-direction: row;
    display: flex;
    gap: 4px;
    flex-wrap: wrap;

    @media screen and (max-width: 768px) {
        justify-content: flex-start;
        gap: 8px;
    }
`;
